"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSummerCottage = function IconSummerCottage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M7.561 29.734 13.1 5.357 19.383 33H14v5h-2v-5h-1v-2h5.876L13.1 14.384 9.015 32.362l-.903-.206L9.212 37H6v2.875a24 24 0 0 1-2-2.604V37h-.178a24 24 0 0 1-2.154-4.192l3.29-14.527zM21.01 7V6h-3l-.167.012A2.001 2.001 0 0 0 18.115 10h8.735l.13.009a.99.99 0 0 1 .86.988l1 .006-.007-.175A1.99 1.99 0 0 0 26.85 9H18.1l-.123-.003a1.002 1.002 0 0 1-.803-1.471A1 1 0 0 1 18.025 7zM31 16.35V13h-5v14h.03l-5.6 12H25v4h2v-6h-3.43L36 10.364l10.402 22.265q.529-1.373.89-2.82L36 5.636zm-3 6.428V15h1v5.635zM33 37v-7h6v7zm5-1v-5h-4v5zM6.706 35l-1.745-7.68L3.221 35z",
    clipRule: "evenodd"
  })));
};

export { IconSummerCottage, IconSummerCottage as default };
